import useIsBrowser from 'hooks/useIsBrowser';

// Please note: when possible it is preferred that responsive width-based
// conditional checks such as the isMobile function are used, but in rare cases
// where we need to check for iPad user agents we can use this hook.
const useIsiPadUserAgent = () => {
  const isBrowser = useIsBrowser();

  // Always return false until the component has mounted in the browser, to
  // prevent SSR hydration errors
  return (
    isBrowser &&
    ((navigator?.userAgent &&
      // iOS < 13
      navigator.userAgent.match(/(iPad)/)) ||
      // iOS 13+
      // Please note: if a touchscreen Mac is released in the future, or the
      // iPad user agent changes then this may need to be updated
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
  );
};

export default useIsiPadUserAgent;
